import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"theme-features"}},[_c('base-section-heading',{attrs:{"title":"Nos Principes fondateurs"}}),_c(VContainer,[_c(VRow,_vm._l((_vm.features),function(feature,i){return _c(VCol,{key:i,attrs:{"cols":"12","md":"6"}},[_c('base-avatar-card',_vm._b({attrs:{"align":"left","horizontal":""}},'base-avatar-card',feature,false),[_vm._v(" "+_vm._s(feature.content)+" ")])],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }